var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcquiredStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.765,
    height: 50.342,
    viewBox: "0 0 57.765 50.342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__icons8-error",
    fill: "#2e2d79",
    d: "M46.518 23.6a6.355 6.355 0 0 0-5.483 3.115l-22.492 37.57a6.4 6.4 0 0 0 5.421 9.657H69.01a6.241 6.241 0 0 0 5.545-3.242 6.387 6.387 0 0 0-.062-6.417L52 26.715a6.355 6.355 0 0 0-5.482-3.115zm0 3.738a2.491 2.491 0 0 1 2.243 1.308l22.555 37.57a2.734 2.734 0 0 1 .062 2.68 2.643 2.643 0 0 1-2.306 1.304H23.965a2.72 2.72 0 0 1-2.306-1.3 2.59 2.59 0 0 1 .062-2.68l22.555-37.57a2.616 2.616 0 0 1 2.242-1.312zm0 12.275a1.836 1.836 0 0 0-1.869 1.869v13.084a1.869 1.869 0 0 0 3.738 0V41.482a1.836 1.836 0 0 0-1.869-1.869zm0 19.439a1.869 1.869 0 1 0 1.869 1.869 1.869 1.869 0 0 0-1.869-1.87z",
    transform: "translate(-17.624 -23.6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcquiredStep2);
export default __webpack_public_path__ + "static/media/acquired-step2.fb4d537f091f7e152f26ab457df612d7.svg";
export { ForwardRef as ReactComponent };